import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LGEResultsStatusEnum } from 'src/app/enums/LGEResultsStatusEnum';
import { IShadowTableData } from 'src/app/interfaces/IShadowTableData';
import { ITableHeader } from 'src/app/interfaces/ITableHeader';
import { ITableHeader2 } from 'src/app/interfaces/ITableHeader2';
import { LGElection } from 'src/app/models/LGElection';
import { ApiDataService } from 'src/app/services/api-data.service';
import { LgElectionService } from 'src/app/services/lg-election.service';

@Component({
  selector: 'app-lge-election-results',
  templateUrl: './lge-election-results.component.html',
  styleUrls: ['./lge-election-results.component.scss']
})
export class LgeElectionResultsComponent implements OnInit {
  @Input() election: LGElection | null = null;
  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();


  public columns: ITableHeader2[] = [];
  public shadowTable: IShadowTableData[][] = [];
  public dataSource: any = null;
  public displayedColumns: string[] = [];
  public isFinalResult = false;
  public isProvisional = false;
  
  constructor(
    public lgElectionService: LgElectionService,
    private apiDataService: ApiDataService,
    public decimalPipe: DecimalPipe
  ) { 
    this.lgElectionService.dataLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(dataLoaded => {
      this.loadTable();
    });
  }


  ngOnInit(): void {
    this.loadTable();
  }

  
  public customTrackBy(index: any, item: any) { 
    return item.column; 
  }


  private loadTable(): void {
    this.columns = [];
    this.shadowTable = [];

 
    this.isFinalResult = this.election?.electionResultStatus === LGEResultsStatusEnum.final ||
      this.election?.electionResultStatus === LGEResultsStatusEnum.declaration;

    this.isProvisional = this.election?.electionResultStatus === LGEResultsStatusEnum.declaration;
    this.columns.push({
      column: '0',
      labels: ['Candidates'],
      minWidth: 250,
      isBold: false,
      isRightJustify: false,
      isPercent: false,
      isColour: false,
      isColourBar: false,
      colourCode: null
    });

    this.columns.push({
      column: '1',
      labels: ['First', 'Preference' , 'Votes'],
      minWidth: 60,
      isBold: false,
      isRightJustify: true,
      isPercent: false,
      isColour: false,
      isColourBar: false,
      colourCode: null
    });

    this.columns.push({
      column: '2',
      labels: ['Elected', 'or', 'Excluded'],
      minWidth: 80,
      isBold: false,
      isRightJustify: true,
      isPercent: false,
      isColour: false,
      isColourBar: false,
      colourCode: null
    });

    this.columns.push({
      column: '3',
      labels: ['Votes at','Election', 'or Exclusion'],
      minWidth: 60,
      isBold: false,
      isRightJustify: true,
      isPercent: false,
      isColour: false,
      isColourBar: false,
      colourCode: null
    });

    // this.columns.push({
    //   column: '4',
    //   labels: ['Count', 'No'],
    //   minWidth: 60,
    //   isBold: false,
    //   isRightJustify: true,
    //   isPercent: false,
    //   isColour: false,
    //   isColourBar: false,
    //   colourCode: null
    // });

    let tmpResultRow: IShadowTableData[] = [];
    const tmpQuota = this.election?.quota ?? 0;
    this.election?.candidates.forEach((candidate, index) => {
      tmpResultRow = [];
      tmpResultRow.push({
        isNumber: false,
        numberData: 0,
        stringData: candidate.candidateName,
        isBold: false
      });
      tmpResultRow.push({
        isNumber: false,
        numberData: 0,
        stringData: this.decimalPipe.transform(candidate.firstPreferenceCount, '') ?? '',
        isBold: false
      });
      tmpResultRow.push({
        isNumber: false,
        numberData: 0,
        stringData: this.isFinalResult ? (candidate.isElected ? `Elected ${candidate.orderOfElection}` : (candidate.countNo > 0 ? 'Excluded' : '')) : '',
        isBold: false
      });
      tmpResultRow.push({
        isNumber: false,
        numberData: 0,
        stringData: this.isFinalResult ? (candidate.votesAtConclusion >= tmpQuota ? 'Quota' : this.decimalPipe.transform(candidate.votesAtConclusion, '')?.toString() ?? '') : '',
        isBold: false
      });
      // tmpResultRow.push({
      //   isNumber: false,
      //   numberData: 0,
      //   stringData: candidate.countNo > 0 ? candidate.countNo.toString() : '',
      //   isBold: false
      // });
      this.shadowTable.push(tmpResultRow);
    });


    const output = [];
    for (let i = 0; i < this.shadowTable.length; i++) {
      const newObj: {[k: string]: any} = {};
      for (let j = 0; j < this.columns.length; j++) {
        const tmpName: string = this.columns[j].column;
        const x = tmpName;
        const tmp = this.shadowTable[i][j].isNumber ? +this.shadowTable[i][j].numberData : this.shadowTable[i][j].stringData;
        newObj[tmpName] = tmp;
      }
      output.push(newObj);
    }


    this.displayedColumns = this.columns.map(c => c.column);
   
    if (this.shadowTable?.length > 0) {
      this.dataSource = new MatTableDataSource(output);
    }

  }


  public isBold(data: string): boolean {
    return data === 'Progressive Total' || data === 'Final District Totals' || data === 'Final %' || data == 'Election Result';
  }


  public openScrutinySheet(url: string): void {
    this.apiDataService.downloadDocumentBlob$(url).subscribe(res => {
      const fileURL = URL.createObjectURL(res);
      window.open(fileURL, '_blank');
    }); 

  }

}
